// Dynamic table is not composable currently, this is an override similar to AdminHub's TableWrapper
// We may make this generic for additional tables across Fastshift.
/* eslint-disable-next-line local/no-block-disable-of-nested-eslint */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
import React from 'react';

import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const StyledFastshiftTableWrapper = styled.div({
	'> div': {
		margin: 0,
		borderInline: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
	},

	'> div:first-of-type': {
		overflowX: 'auto',
		borderStartStartRadius: '4px',
		borderStartEndRadius: '4px',
		borderTop: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
		borderLeft: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
		borderRight: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
	},
	table: {
		overflowX: 'auto',
		width: '100%',
		minWidth: '1072px',
		borderCollapse: 'collapse',
		borderBlockEnd: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
	},
	'table > thead > tr': {
		height: '40px',
	},
	'table > thead > tr th': {
		paddingBlockStart: token('space.100', '8px'),
		paddingBlockEnd: token('space.100', '8px'),
		borderBlockEndWidth: '1px',
		borderInlineEnd: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
		verticalAlign: 'middle',
	},
	'table > thead > tr th h6': {
		color: token('color.text.subtle', '#505258'),
	},
	'table > tbody': {
		borderBottom: 'none',
	},
	'table > tbody > tr': {
		verticalAlign: 'middle !important',
	},
	'table > caption': {
		margin: 0,
	},
	tr: {
		height: '40px',
		borderBottom: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
	},
	'tr:last-of-type': {
		borderBottom: 'none',
	},
	td: {
		borderInlineEnd: `1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
	},
	'td:last-of-type, th:last-of-type': {
		borderInlineEnd: 'none',
		paddingRight: token('space.100', '8px'),
	},
	'td:first-of-type, th:first-of-type': {
		paddingInlineStart: token('space.100', '8px'),
	},
});

interface FastshiftTableWrapperProps {
	id?: string;
	testId?: string;
}

export const FastshiftTableWrapper: React.FC<
	React.PropsWithChildren<FastshiftTableWrapperProps>
> = ({ children, id = 'fastshift-table-wrapper', testId = 'fastshift-table-wrapper' }) => {
	return (
		<StyledFastshiftTableWrapper data-testid={testId} id={id}>
			{children}
		</StyledFastshiftTableWrapper>
	);
};
